















































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import { required } from 'vuelidate/lib/validators';
import { ApiRequest } from '../../types/request';
import { ObjectFactory } from '../../config/objectFactory';
import { MemberProfile } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { validationMixin } from 'vuelidate';

@Component({
    mixins: [validationMixin],
    props: {
        memberRequest: Object,
    },
    validations() {
        const validations = {
            memberRequest: {
                isCaseManager: {
                    required,
                },
            },
        };
        return validations;
    },
})
export default class MemberType extends Vue {

    private memberProfile: any = {};
    private async mounted() {
        if (!this.memberProfile.fullname) {
            const userId = ObjectFactory.getCacheService().getSessionInfo().id;
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_USERS}/${userId}`,
            };
            const response = await ObjectFactory.getHttpService().get<MemberProfile>(apiRequest);
            if (response.success) {
                this.memberProfile = response.data;
            } else {
                CommonUtils.showError(response);
            }
        }
    }

    private saveMemberType() {
        if (this.$props.memberRequest.memberType === 'ORG_MANAGER') {
            this.$router.push({ name: MedTransGoConstants.VIEW_ORGANIZATION_NAME });
        } else {
            this.$router.push({ name: MedTransGoConstants.VIEW_PAYMENT_INFORMATION_NAME });
        }
    }

    private setMemberType(type: string) {
        this.$props.memberRequest.memberType = type;
    }

    private getQuestionCounter(index: number) {
        const counter = ++index;
        return counter;
    }
}
